import React from "react"
import clsx from "clsx"
import SvgIcon from "@material-ui/core/SvgIcon"
import { makeStyles } from "@material-ui/core/styles"

import { ReactComponent as LogoSvg } from "../assets/logo.svg"

const useStyles = makeStyles((theme) => {
  return {
    logo: {
      float: "left",
      marginLeft: theme.spacing(1),
      textAlign: "left",
      width: theme.spacing(12),
      height: theme.spacing(4),
      color: theme.palette.primary.contrastText,
    },
    closed: {
      "& path": {
        display: "none",
      },
    },
    bar: {
      color: theme.palette.primary.main,
      marginLeft: theme.spacing(2),
    },
  }
})

const Logo = ({ bar, logoProps, open, ...props }) => {
  const classes = useStyles()

  return (
    <SvgIcon
      viewBox="0 0 332.43 112.96"
      className={clsx(classes.logo, {
        [classes.closed]: !open,
        [classes.bar]: bar,
      })}
      {...props}
    >
      <LogoSvg {...logoProps} />
    </SvgIcon>
  )
}

export default Logo
